import { useEffect } from "react";
import { FaCheckCircle, FaExclamationCircle, FaTimes } from "react-icons/fa";

export default function Toast({ type = "success", message, onClose, duration = 4500 }) {
  useEffect(() => {
    if (!message) return undefined;
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [message, type, duration, onClose]);

  if (!message) return null;

  const isSuccess = type === "success";

  return (
    <div
      className={`theme_toast ${isSuccess ? "theme_toast_success" : "theme_toast_error"}`}
      role="status"
      aria-live="polite"
    >
      <span className="theme_toast_icon">
        {isSuccess ? <FaCheckCircle /> : <FaExclamationCircle />}
      </span>
      <p className="theme_toast_message">{message}</p>
      <button
        type="button"
        className="theme_toast_close"
        onClick={onClose}
        aria-label="Dismiss notification"
      >
        <FaTimes />
      </button>
    </div>
  );
}
